import layout from './TokenValidation.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import View from '@/Views/View';
import TokenValidationViewModel from '@/Components/TwoFaktorAuth/LoginFlow/TokenValidation/TokenValidationViewModel';

export default class TokenValidationView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(public viewModel: TokenValidationViewModel, private element?: JQuery) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('TokenValidationView', TokenValidationView, 'RADPresentation.HTMLClient.DefaultViewExtensions');